/**
 * PromotionBadge component - Type indicator for combo/discount promotions
 */

import React from 'react';
import { Chip, Box } from '@mui/material';
import { LocalFireDepartment as FireIcon, MonetizationOn as MoneyIcon } from '@mui/icons-material';
import colors from '../../../themes/colors';
import { promotionTypography } from '../../../themes/typography';

/**
 * Badge component to indicate promotion type
 */
const PromotionBadge = ({ type, sx = {} }) => {
  
  const badgeConfig = {
    combo: {
      label: '🔥 COMBO',
      icon: <FireIcon fontSize="small" />,
      color: colors.promotion.combo,
      bgColor: `${colors.promotion.combo}15`, // 15% opacity
    },
    discount: {
      label: '💰 ESPECIAL',
      icon: <MoneyIcon fontSize="small" />,
      color: colors.promotion.discount,
      bgColor: `${colors.promotion.discount}15`, // 15% opacity
    }
  };

  const config = badgeConfig[type] || badgeConfig.discount;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mb: 2,
        ...sx
      }}
    >
      <Chip
        icon={config.icon}
        label={config.label}
        sx={{
          ...promotionTypography.badge,
          bgcolor: config.bgColor,
          color: config.color,
          border: `1px solid ${config.color}30`,
          fontWeight: 600,
          px: 1,
          py: 0.5,
          height: 'auto',
          '& .MuiChip-icon': {
            color: config.color,
            fontSize: '1rem'
          },
          '& .MuiChip-label': {
            px: 1,
            fontSize: 'inherit',
            fontWeight: 'inherit',
            textTransform: 'inherit',
            letterSpacing: 'inherit'
          },
          boxShadow: `0 2px 8px ${config.color}20`,
          animation: 'pulse 2s infinite',
          '@keyframes pulse': {
            '0%': {
              boxShadow: `0 2px 8px ${config.color}20`
            },
            '50%': {
              boxShadow: `0 2px 16px ${config.color}40`
            },
            '100%': {
              boxShadow: `0 2px 8px ${config.color}20`
            }
          }
        }}
      />
    </Box>
  );
};

export default PromotionBadge;